// Get the value of a specific cookie
function getCookieValue(name) {
	var allCookies  = "; " + document.cookie;
	var cookieParts = allCookies.split( "; " + name + "=" );

	if (cookieParts.length > 0) {
		// Return found cookie as a String
		return cookieParts
			.pop()
			.split( ";" )
			.shift()
			.toString();
	}

	return false;
}
